// 请求函数封装
// import axios from "axios";
// import qs from "qs";
// import url from "./url";
// import helper from "./helper";

let util = {};
let axios = null;
let qs = null;
let Axios = null;
// let helper=null;
Object.defineProperty(util, "axios", {
  get() {
    if (!axios) {
      axios = require("axios");
    }
    return axios;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(util, "qs", {
  get() {
    if (!qs) {
      qs = require("qs");
    }
    return qs;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(util, "Axios", {
  get() {
    if (!Axios) {
      initAxios();
    }
    return Axios;
  },
  enumerable: true,
  configurable: true
});

const defaultTimeOut = 20000;
const sessionTimeoutCodes = ["29401", "29402", "29404", "29405", "29406", "29408"];
const deviceChangeCodes = ["29407"];
let sysInterceptorsResponse = false;
let requestUse = [];
let responseUse = [];
let uid = 0;

function initAxios() {
  Axios = util.axios.create({
    baseURL: "",
    timeout: defaultTimeOut,
    responseType: "json",
    crossDomain: true,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    }
    // withCredentials: true
    // withCredentials设置为true，后端设置的请求标头Access-Control-Allow-Origin'不能为*，跨域处理需要设置为获取的当前请求的origin
  });
  const buriedPointApiUrl = "/api/statistics/es/add/info";
  const buriedPointInfos = [];

  Axios.interceptors.request.use((request) => {
    // request.uid=dsf.uuid();
    dsf.performance.start("http请求:" + ++uid + request.url);
    request.uid = uid;
    if (buriedPointOn()) {
      let time = new Date();
      request._currentTime = time.getTime();
      request._currentTime2 = dsf.date.format(time, "yyyy-mm-dd hh:ii:ss");
      request._cookie = document.cookie;
      request._requestClient = window.navigator.userAgent;
    }
    return request;
  });
  // const DEFAULT_ERROR = "网络存在异常";
  Axios.interceptors.response.use(
    (response) => {
      dsf.performance.end("http请求:" + response.config.uid + response.config.url);
      //处理前端埋点
      let isBuriedPointApiUrl = response.config.url.endsWith(buriedPointApiUrl);
      let isDsfApi = dsf.isDef(response?.data?.state) && dsf.isDef(response?.data?.success);
      if (buriedPointOn() && response?.config && !isBuriedPointApiUrl && isDsfApi) {
        let appRoot =dsf.getVueAppRoot();
        let result = true;
        if (appRoot) {
          let buriedPointCallBack = appRoot?.options?.buriedPoint?.pushAccept;
          result = buriedPointCallBack?.call?.(appRoot, response);
        }
        if (result !== false) {
          pushBuriedPointInfos(response);
          startBuriedPoint(false);
        }
      }
      //处理IE9请求json时不能自动转化成对象的问题
      if (response.data == null && response.config.responseType === "json" && response.request.responseText != null) {
        try {
          response.data = JSON.parse(response.request.responseText);
        } catch (e) {
          // ignored
        }
      }
      if (response?.data?.state && dsf.isFunction(dsf.http.platformCommonInterceptors)) {
        let result = dsf.http.platformCommonInterceptors(response);
        if (result) {
          return result;
        }
      }
      return response;
    },
    (error) => {
      let throwError = true;
      if (error.message.indexOf("Request failed with status code") >= 0) {
        error.message = error.message.replace("Request failed with status code", "请求发生错误，错误代码:");
      } else if (error.message.indexOf("timeout of") >= 0) {
        dsf.error(error);
        error.message = dsf.config.http.timeoutMessage;
      } else if (error.message.indexOf("Network Error") == 0) {
        dsf.error(error);
        error.message = "网络错误";
      } else if (error.message.indexOf("Request aborted") >= 0) {
        dsf.error(error);
        error.message = "";
      }
      if (throwError) {
        return Promise.reject(error);
      }
    }
  );
}

//平台自定义公共拦截
function platformCommonInterceptors(response) {
  let message = "";
  //拦截session丢失，后端返回的错误码
  if (sessionTimeoutCodes.indexOf(response.data.state.toString()) >= 0) {
    if (response.data.state.toString() == "29408") {
      message = response.data.message;
    } else if (response.data.state.toString() == "29401") {
      // message = "您的会话已过期，请重新登录";
      return new Promise((resolve, reject) => {
        goToUnauthorized();
      });
    } else {
      message = dsf.config.setting_public_token_invalid;
    }
  }
  //用户在另一台设备登录
  else if (deviceChangeCodes.indexOf(response.data.state.toString()) >= 0) {
    message = "当前用户已在其他设备登录";
  }
  if (message) {
    if (!sysInterceptorsResponse) {
      sysInterceptorsResponse = true;
      return new Promise((resolve, reject) => {
        openSystemAlert(
          message,
          {
            code: response?.data?.state,
            message: message
          },
          goTologin,
          goTologin
        );
      });
    } else {
      return new Promise(dsf.noop);
    }
  }
}

/*埋点任务 start*/
function buriedPointOn() {
  return dsf.config.setting_public_interface_statistics == "1";
}
function startBuriedPoint(isIdle = true) {
  if (window.requestIdleCallback && isIdle) {
    window.requestIdleCallback($postBuriedPointInfo, { timeout: 1000 });
  } else {
    $postBuriedPointInfo({
      didTimeout: false,
      timeRemaining: function () {
        return 1;
      }
    });
  }
}
function $postBuriedPointInfo(deadline) {
  while ((deadline.timeRemaining() > 0 || deadline.didTimeout) && buriedPointInfos.length) {
    let task = buriedPointInfos.shift();
    postBuriedPointInfo(task);
  }
  if (buriedPointInfos.length) {
    startBuriedPoint();
  }
}
function postBuriedPointInfo(response) {
  try {
    let { config, headers, status } = response;
    let requestUrl = dsf.url.parse(config.url);
    let requestParamsData = dsf.url.queryStringParse(config.data);
    let params = {
      interfaceAddr: requestUrl.pathname,
      createTime: config._currentTime2,
      responseTime: new Date().getTime() - config._currentTime,
      cookie: config._cookie,
      requestHeader: JSON.stringify(config.headers),
      requestParams: JSON.stringify({
        urlParams: config.params,
        data: requestParamsData
      }),
      responseHeader: JSON.stringify(headers),
      responseCode: status,
      requestClient: config._requestClient
    };
    let server = dsf.config.setting_public_interface_host || "";
    if (server && server.endsWith("/")) {
      server = server.substr(0, server.length - 1);
    }
    let url = [server, buriedPointApiUrl].join("");
    dsf.http.post(url, params);
  } catch (ex) {
    //
  }
}
//推送到埋点任务队列
function pushBuriedPointInfos(response) {
  buriedPointInfos.push(response);
}
/*埋点任务 end */

// let $vueRoot = null;
// function getVueRoot() {
//   if (!$vueRoot) {
//     $vueRoot = document.querySelector("#app")?.__vue__?.$root;
//   }
//   return $vueRoot;
// }

//跳转到登录页
function goTologin(error) {
  let vueRoot = dsf.getVueAppRoot();
  if (vueRoot && vueRoot.$options.sessionCatch) {
    vueRoot.$options.sysCatch(error);
    return;
  }
  dsf.loginOut()
}
//弹出系统级错误提示
function openSystemAlert(message, error, yes, cancel) {
  if (dsf.global.$isMobile) {
    //如果是移动端需要清理掉vant的loading组件，负责会导致页面无法点击
    let toasts = document.querySelectorAll(".van-toast--loading");
    for (let i = 0; i < toasts.length; i++) {
      dsf.layer.closeLoading(toasts[i]?.__vue__?.$parent);
    }
  }
  // setTimeOut是为了防止 系统弹窗（比如重置密码框）覆盖系统错误提示（比如 需重置密码提示）
  setTimeout(()=>{
    dsf.layer
      .alert(message)
      .then(() => {
        sysInterceptorsResponse = false;
        yes(error);
      })
      .catch(() => {
        sysInterceptorsResponse = false;
        cancel(error);
      });
  },150)
}
function getMobileUrl401() {
  let currUrl = dsf.url.parse(window.location.href);
  let searchQuery = currUrl.searchQuery;
  if (dsf.isUnDef(searchQuery) || dsf.isEmptyObject(searchQuery)) {
    searchQuery = null;
  }
  let url = currUrl.origin + currUrl.path;
  let e401Url = dsf.url.parse("./mobile-index.html#/mobile/error401");
  url += e401Url.hash;
  return url;
}
//跳转到401页面
function goToUnauthorized(error) {
  // let topWin = dsf.getTopWindow();
  // let root = topWin.__multiPageVm__ ? topWin : window;
  let vueRoot = dsf.getVueAppRoot();
  if (vueRoot && vueRoot.$options.sessionCatch) {
    vueRoot.$options.sysCatch(error);
    return;
  }
  let url="./page.html#/pc/error401";
  if (dsf.global.$isMobile) {
    url = getMobileUrl401();
  }
  dsf.loginOut(url)
}
let done = (Promise.prototype.done = function (fn) {
  function responseHanlder(response) {
    if (response.headers) {
      var result = response.data || {};
      //success、state、message这3个属性都存在表示是我们自己应用的程序
      if (dsf.isDef(result.success) && dsf.isDef(result.state) && dsf.isDef(result.message)) {
        return fn(result);
      } else {
        return fn(result);
      }
    } else {
      var result = response;
      //success、state、message这3个属性都存在表示是我们自己应用的程序
      if (dsf.isDef(result.success) && dsf.isDef(result.state) && dsf.isDef(result.message)) {
        return fn(result);
      } else {
        return fn(result);
      }
    }
  }
  let r = this.then((response) => {
    if (response !== void 0) {
      return responseHanlder(response);
    }
  });
  attachDoneErrorAlways(r);
  return r;
});

let error = (Promise.prototype.error = function (fn) {
  function errorHandler(error) {
    let err = { message: "" };
    if (dsf.type(error) == "string") {
      err = {
        message: error
      };
    } else if (dsf.type(error) == "error" || dsf.type(error) == "object") {
      if (error.message == "sessionTimeout") {
        dsf.httpError(error);
        return;
      }
      err = {
        message: error.message
      };
    } else {
      err = {
        message: "服务器异常"
      };
    }
    dsf.error(error);
    fn(err);
  }
  let r = this.catch((error) => {
    errorHandler(error);
  });
  attachDoneErrorAlways(r);
  return r;
});

let always = (Promise.prototype.always = function (fn) {
  let r = this.finally(fn);
  attachDoneErrorAlways(r);
  return r;
});

let _Promise = Promise;
function attachDoneErrorAlways(promise) {
  //分包后导致项目层的Promise和平台层的Promise不是同一个对象而导致Promise无效
  // if (client.type.startsWith("IE") && window.Promise) {
  //   window.Promise = _promise;
  // }
  if (promise) {
    promise.done = done;
    promise.error = error;
    promise.always = always;
  }

  // 修复火狐低版本兼容问题
  let P = promise?.constructor;
  if (P && P !== _Promise) {
    P.prototype.done = done;
    P.prototype.error = error;
    P.prototype.always = always;
  }
}
// IEPromiseSupport()
function getToken() {
  return dsf.cookies.get(dsf.config.setting_public_tokenkey) || "";
}

function setHttpDisableCache(opts) {
  if (dsf.isUnDef(opts.headers)) {
    opts.headers = {};
  }
  opts.headers["Cache-Control"] = "no-cache";
  opts.headers["Pragma"] = "no-cache";
}

function get(path, params, options, baseUrl) {
  // IEPromiseSupport();
  if (dsf.type(options) == "string") {
    baseUrl = options;
    options = null;
  }
  path = dsf.url.getWebPath(path, baseUrl);
  let opts = {
    params: params || {},
    paramsSerializer: function (params) {
      return util.qs.stringify(params, {
        arrayFormat: "repeat"
      });
    },
    timeout: dsf.config.http.timeout
  };
  opts = dsf.mix(true, opts, options || {}, {
    headers: dsf.getDefaultHttpHeader()
  });
  if (!opts.cache) {
    setHttpDisableCache(opts);
    // opts.params._t = new Date().getTime();
    delete opts.cache;
  }
  let p = util.Axios.get(path, opts);

  attachDoneErrorAlways(p);
  return p;
}

function post(path, params, options, baseUrl) {
  // IEPromiseSupport();
  if (dsf.type(options) == "string") {
    baseUrl = options;
    options = null;
  }
  path = dsf.url.getWebPath(path, baseUrl);

  let configContentType = options && options.headers && options.headers["Content-Type"] ? options.headers["Content-Type"] : "";
  //raw-json提交
  if (configContentType.indexOf("application/json") >= 0) {
    if (dsf.isObject(params) || dsf.isArray(params)) {
      params = JSON.stringify(params);
    }
  } else {
    // if (configContentType.indexOf("multipart/form-data") < 0 && dsf.isObject(params)) {
    //   params = qs.stringify(params);
    // }
    //普通的form提交，不包含上传文件
    if (dsf.isObject(params) && configContentType.indexOf("multipart/form-data") < 0) {
      params = util.qs.stringify(params);
    }
  }
  let opts = {
    timeout: dsf.config.http.timeout
  };
  opts = dsf.mix(true, opts, options || {}, {
    headers: dsf.getDefaultHttpHeader()
  });
  let p = util.Axios.post(path, params, opts);
  attachDoneErrorAlways(p);
  return p;
}

function all(arr) {
  return util.axios.all(arr).then(
    util.axios.spread((...res) => {
      const list = res.map((item) => item.data);
      return list;
    })
  );
}
function allSettled(arr) {
  return Promise.allSettled(arr).done((res) => {
    let validData = [];
    _.forEach(res, (item) => {
      if (item.status === "fulfilled") {
        const requestData = item.value.data;
        // 请求文件无success标志
        if (requestData.success === false) {
          validData.push({ success: false, data: requestData.message });
        } else if (requestData.success === true) {
          validData.push({ success: true, data: requestData.data });
        } else {
          validData.push({ success: true, data: requestData });
        }
      } else {
        validData.push({ success: false, reason: item.reason });
      }
    });
    return validData;
  });
}
function upload(path, params, options, baseUrl) {
  // IEPromiseSupport();
  if (dsf.type(options) == "string") {
    baseUrl = options;
    options = null;
  }
  let opts = dsf.mix(true, options || {}, {
    headers: {
      "Content-Type": "multipart/form-data",
      ...dsf.getDefaultHttpHeader()
    },
    timeout: 0
  });
  var forms = new FormData();

  for (let k in params) {
    if (params[k] instanceof Blob) {
      forms.append(k, params[k], params[k]?.name);
    } else {
      forms.append(k, params[k]);
    }
  }
  path = dsf.url.getWebPath(path, baseUrl);
  let p = util.Axios.post(path, forms, opts);
  attachDoneErrorAlways(p);
  return p;
}

//

let $$allLoadFiles = {};

async function importFiles(files) {
  let loadFiles = dsf.type(files) == "array" ? files.slice(0) : [files];
  let neetLoadFiles = [];
  _.each(loadFiles, (it) => {
    neetLoadFiles.push(it);
  });
  let arr = [];
  for (let i = 0; i < neetLoadFiles.length; i++) {
    let res = null;
    try {
      if (dsf.isArray(neetLoadFiles[i])) {
        res = await loadFile(neetLoadFiles[i][0], neetLoadFiles[i][1]);
      } else {
        res = await loadFile(neetLoadFiles[i]);
      }
    } catch (ex) {
      res = ex;
    } finally {
      arr.push(res);
    }
  }
  let error = _.filter(arr, (it) => it.state == "error");
  if (error.length) {
    throw arr;
  } else {
    return arr;
  }
}

function getFileType(url) {
  if (url != null && url.length > 0) {
    if (url.lastIndexOf("?") > 0) {
      url = url.substr(0, url.lastIndexOf("?"));
    }
    return url.substr(url.lastIndexOf(".")).toLowerCase();
  }
}

function loadFile(url, type) {
  // IEPromiseSupport();
  type = type || getFileType(url);
  let fileObj = null;
  let promise = null;
  if ($$allLoadFiles[url]) {
    let state = $$allLoadFiles[url].state;
    //如果当前script已经存在但正在加载中
    if (state == "pending") {
      promise = $$allLoadFiles[url].promise;
    }
    // 如果当前script已经存在且加载完毕
    else if (state == "success") {
      promise = Promise.resolve($$allLoadFiles[url]);
    }
    //如果当前script加载错误
    else if (state == "error") {
      promise = Promise.reject($$allLoadFiles[url]);
    }
  } else {
    if (type == ".js") {
      fileObj = document.createElement("script");
      fileObj.src = url;
    } else if (type == ".css") {
      fileObj = document.createElement("link");
      fileObj.href = url;
      fileObj.type = "text/css";
      fileObj.rel = "stylesheet";
    }
    if (fileObj) {
      promise = new Promise((resolve, reject) => {
        fileObj.onload = fileObj.onreadystatechange = function () {
          if (!this.readyState || "loaded" === this.readyState || "complete" === this.readyState) {
            $$allLoadFiles[url].state = "success";
            resolve($$allLoadFiles[url]);
            delete $$allLoadFiles[url].promise;
          }
        };
        fileObj.onerror = function () {
          $$allLoadFiles[url].state = "error";
          reject($$allLoadFiles[url]);
          delete $$allLoadFiles[url].promise;
        };
      });
      if (!$$allLoadFiles[url]) {
        $$allLoadFiles[url] = {
          elem: fileObj,
          state: "pending",
          type: type,
          src: url,
          promise: promise
        };
        document.getElementsByTagName("BODY")[0].appendChild(fileObj);
      }
    } else {
      promise = Promise.reject($$allLoadFiles[url]);
    }
  }
  attachDoneErrorAlways(promise);
  return promise;
}
importFiles.kill = function (src, mark) {
  let f = $$allLoadFiles[src];
  if (f && f.elem && f.elem.parentNode) {
    f.elem.parentNode.removeChild(f.elem);
  }
  delete $$allLoadFiles[src];
};
importFiles.has = function (src) {
  let result = $$allLoadFiles[src] && $$allLoadFiles[src].state == "success";
  return result ? true : false;
};

let m = {
  get,
  post,
  all,
  allSettled,
  upload,
  importFiles,
  platformCommonInterceptors
};
Object.defineProperty(m, "interceptors", {
  get() {
    return util.Axios.interceptors;
  },
  enumerable: true
});
export default m;

// 示例:
// this.dsf.http.get('wfm/getWFDefinition', {
//   sID: '5b2d48d830c44b509d4fa730fa9d0b9b'
// }).done((d) => {
//   _this.dsf.layer.toast('模拟Get请求成功', true)
// }).error((response) => {
//   _this.dsf.layer.toast('模拟Get请求失败', false)
// }).always((res) => {
// })

// this.dsf.http.post('dsfa/tags/saveOrCancel', {
//   ywlxValue: '00',
//   ywlxText: '课程',
//   ywid: '6ec7aadc7e1c49a7a3ac454d939da5cd'
// }).done((d) => {
//   _this.dsf.layer.toast('模拟Post请求成功', true)
// }).error((response) => {
//   _this.dsf.layer.toast('模拟Post请求失败', false)
// }).always((res) => {
// })
